import { render, staticRenderFns } from "./taskDetails.vue?vue&type=template&id=6d93bbe6&scoped=true"
import script from "./taskDetails.vue?vue&type=script&lang=js"
export * from "./taskDetails.vue?vue&type=script&lang=js"
import style0 from "./taskDetails.vue?vue&type=style&index=0&id=6d93bbe6&scoped=true&lang=css"
import style1 from "./taskDetails.vue?vue&type=style&index=1&id=6d93bbe6&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d93bbe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d93bbe6')) {
      api.createRecord('6d93bbe6', component.options)
    } else {
      api.reload('6d93bbe6', component.options)
    }
    module.hot.accept("./taskDetails.vue?vue&type=template&id=6d93bbe6&scoped=true", function () {
      api.rerender('6d93bbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/task/taskDetails.vue"
export default component.exports